// extracted by mini-css-extract-plugin
export default {"rankValue":"RankDisplay_rankValue__pEVPo","currentRank":"RankDisplay_currentRank__1wqEP","separator":"RankDisplay_separator__wx6Ha","totalRanks":"RankDisplay_totalRanks__gKRdI"};